"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HOW_CAN_WE_HELP_IMAGE_URL = exports.CONTACT_US_PATH = void 0;
const HOW_CAN_WE_HELP_IMAGE_URL = exports.HOW_CAN_WE_HELP_IMAGE_URL = 'https://media-cdn.oriflame.com/contentImage?externalMediaId=362ec2f7-7814-429c-9d78-290d40141b8b&name=SupportCenter&inputFormat=png';
const CONTACT_US_PATH = exports.CONTACT_US_PATH = '/support-center/company-information/local-information/how-can-i-contact-oriflame';
